// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2LVac","footer":"ModalFilter_footer__2PASj"};